namespace TabAurous.HR {
    export interface PayrollEmployeeDetailsForm {
        EmployeeId: Serenity.StringEditor;
        ComponentId: Serenity.IntegerEditor;
        Percentage: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
    }

    export class PayrollEmployeeDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'HR.PayrollEmployeeDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PayrollEmployeeDetailsForm.init)  {
                PayrollEmployeeDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(PayrollEmployeeDetailsForm, [
                    'EmployeeId', w0,
                    'ComponentId', w1,
                    'Percentage', w2,
                    'Amount', w2
                ]);
            }
        }
    }
}
